module.exports = __webpack_public_path__ + "images/icon/article-2b36b61f.svg";